import { render, staticRenderFns } from "./whatsappMessage.vue?vue&type=template&id=56cc93eb&scoped=true&"
import script from "./whatsappMessage.vue?vue&type=script&lang=js&"
export * from "./whatsappMessage.vue?vue&type=script&lang=js&"
import style0 from "./whatsappMessage.vue?vue&type=style&index=0&id=56cc93eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc93eb",
  null
  
)

export default component.exports